import { MenuItem } from "@mui/material";

import { IRules, IRulesInvoicing, InvoicingType, PaymentMethodType, ChargeType } from "../../Setup.types";
import { Container, Row, SelectForm, TextField } from "./Rules.styled";

interface IProps {
  rules: IRules;
  handleChange: (payload: Partial<IRules>) => void;
}

export function RulesTabInvoicing({ rules, handleChange }: IProps) {
  /** Função responsável especificamente por receber os valores alterados e formatar corretamente para handleChange. */
  function handleChangeInvoicing(payload: Partial<IRulesInvoicing>) {
    const updatedInvoicingFields = { ...rules.rulesInvoicing, ...payload };

    handleChange({ ...rules, rulesInvoicing: updatedInvoicingFields });
  }

  return (
    <Container>
      <Row>
        <SelectForm
          label="Tipo da fatura (formação de preço)"
          value={rules.rulesInvoicing.invoicingType}
          onChange={(e) => handleChangeInvoicing({ invoicingType: e.target.value as InvoicingType })}
        >
          <MenuItem value={"FAIXA_ETARIA"}>Faixa etária</MenuItem>
          <MenuItem value={"PRECO_MEDIO"}>Preço médio</MenuItem>
        </SelectForm>
        <SelectForm
          label="Forma de pagamento"
          value={rules.rulesInvoicing.paymentMethod}
          onChange={(e) => handleChangeInvoicing({ paymentMethod: e.target.value as PaymentMethodType })}
        >
          <MenuItem value={"BOLETO"}>Boleto</MenuItem>
        </SelectForm>
        <SelectForm
          label="Tipo de cobrança"
          value={rules.rulesInvoicing.chargeType}
          onChange={(e) => handleChangeInvoicing({ chargeType: e.target.value as ChargeType })}
        >
          <MenuItem value={"PRO_RATA"}>Pro-rata</MenuItem>
          <MenuItem value={"MES_CHEIO"}>Mes cheio</MenuItem>
        </SelectForm>
        <TextField
          label="Vencimento do prêmio (venc fatura)"
          type="number"
          inputProps={{ min: 0 }}
          value={rules.rulesInvoicing.invoiceDueDate}
          onChange={(e) => handleChangeInvoicing({ invoiceDueDate: Number(e.target.value) ?? 0 })}
        />
      </Row>
    </Container>
  );
}
